export const PageGroups = {
  Dashboard: 'Dashboard',
};

export const ComponentGroups = {
  ErrorBoundary: 'ErrorBoundary',
  NoMemberData: 'NoMemberData',
  Footer: 'Footer',
};
